// extracted by mini-css-extract-plugin
export default {"main":"RoleName_main__wBT46","lowContrast":"RoleName_lowContrast__FZi2r"};